import React from 'react';
import Text from './Text';

const SmallCaps = (props) => <Text textTransform="uppercase" fontWeight="bold" {...props} />;

export default SmallCaps;
